/**
 * Creates a reducer function from an initial state and a map of action handlers.
 *
 * @param {*} initState - The initial state for the reducer.
 * @param {Object.<string, function(*, Object): *>} handlers - Map of action
 *   type strings to handler functions. Each handler receives `(state, action)`
 *   and returns the new state.
 * @returns {function(*, Object): *} A reducer function that receives `(state, action)`
 *   and returns the new state, falling back to the current state if no handler
 *   matches `action.type`.
 *
 * @example
 * export default createReducer(ENROLLMENT_INIT_STATE, {
 *   [ENROLLMENT_ACTIONS.STARTED]: state => ({ ...state, loading: true }),
 *   [ENROLLMENT_ACTIONS.SUCCEEDED]: (state, { response }) => ({
 *     ...state,
 *     individuals: response.individuals,
 *   }),
 * });
 */
export const createReducer =
  (initState, handlers) =>
  (state = initState, action) =>
    handlers[action.type]?.(state, action) ?? state;
